import { createInertiaApp } from "@inertiajs/react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { resolveInertiaPage } from "@evo-mark/inertia-wordpress/react";
import DefaultLayout from "./layouts/DefaultLayout.jsx";
import { ProductModalProvider } from "./components/ProductModalProvider";
import "../css/style.css";

createInertiaApp({
  resolve: resolveInertiaPage(
    import.meta.glob("./pages/**/*.jsx", { eager: false }),
    DefaultLayout
  ),
  setup({ el, App, props }) {
    /* hydrateRoot(el, <App {...props} />); */
    createRoot(el).render(
      <ProductModalProvider>
        <App {...props} />
      </ProductModalProvider>
    );
  },
});
